const WORKSHOP_FEEDBACK = [
  "I have never enjoyed a course so much and I leave here today having actually learnt a lot!! Thanks.",
  "Best training I’ve ever been to !!",
  "I strongly recommend this way of educating people in future as it is really effective",
  "Great course, knowledgeable and fun but covered important aspects of job and safety risks.",
  "Such a powerful workshop so engaging",
  "The actors just brought the whole thing to life",
  "I enjoyed it so much I'd go again!",
  "At last I understand what we're battling with on site and how to prevent risk taking",
  "I left the workshop buzzing with a completely new mindset when it comes to safety",
  "If only I'd known these things earlier in my management career",
];

export default function WorkshopFeedbackTicker() {
  if (!WORKSHOP_FEEDBACK.length) return null;
  return (
    <div className="relative overflow-hidden py-6" data-testid="workshop-feedback-ticker" aria-label="Feedback from our workshops">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" aria-hidden="true" />
      <div className="marquee-track items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {WORKSHOP_FEEDBACK.map((quote, i) => (
              <p key={`${half}-${i}`} className="mx-12 whitespace-nowrap font-display text-lg sm:text-xl font-semibold text-teal" data-testid={`workshop-feedback-${half}-${i}`}>
                &ldquo;{quote}&rdquo;
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
